import 'modern-css-reset'
import './tags'
import './pages'

tag app

	<self.app>
		<site-nav selected=imba.router.path>
		<announcement-banner>
		<home-page route='/$'>
		<posts-page route='/posts$'>
		<who-we-are-page route='/who-we-are$'>
		<staff-page route='/staff$'>
		<calendar-page route='/calendar$'>
		<history-page route='/history$'>
		<weddings-page route='/weddings$'>
		<forms-page route='/forms$'>
		<ministry-partners-page route='/partners$'>
		<youth-page route='/youth$'>
		<photos-page route='/photos$'>

imba.mount <app>